export default __webpack_public_path__ + "static/media/logo (3).48ea780c.png";